import { Box, Divider, Flex, Image, useToast, VStack } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import {
  AiOutlineFileText,
  AiOutlineMenu,
  AiOutlineUser,
} from 'react-icons/ai';
import {
  BsBagCheck,
  BsGear,
  BsImages,
  BsPercent,
  BsShieldCheck,
  BsTag,
} from 'react-icons/bs';
import { CgList } from 'react-icons/cg';
import { ImMobile } from 'react-icons/im';
import cms from '../../apis/cms';
import useAuth from '../../hooks/useAuth';
import { MenuLocationsContext } from '../../hooks/useMenuItemsLocation';
import NavGroup from './NavGroup';
import NavItem from './NavItem';

const Aside: React.FC = () => {
  const [logo, setLogo] = useState('');
  const { user } = useAuth();
  const isSysAdmin = user?.roles.includes('sysadmin');

  const { data: dataFromContext } = useContext(MenuLocationsContext);

  const toast = useToast();

  async function getLogo() {
    try {
      const { data } = await cms.rest.get<any>('/config-images/image_menu', {
        params: {
          withFile: true,
        },
      });
      setLogo(data?.file?.url);
    } catch (err: any) {
      toast({
        title: 'Opss!!',
        description:
          err?.response?.data?.message ||
          'Ocorreu um erro ao carregas a telas, tente novamente mais tarde!',
        status: 'error',
        position: 'top-right',
      });
    }
  }

  useEffect(() => {
    getLogo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      py="20px"
      h="100vh"
      maxH="100svh"
      overflowY="auto"
      as="aside"
      flexDir="column"
      w={225}
      flexShrink={0}
      zIndex={20}
      boxShadow="xl"
    >
      {logo ? (
        <Box px="20px" mb={6}>
          <Image src={logo} mb="16px" />
          <Divider />
        </Box>
      ) : (
        ''
      )}

      <VStack as="nav" spacing={0}>
        <>
          <NavItem icon={AiOutlineUser} title="Usuários" to="/users" />
          <NavItem
            icon={ImMobile}
            title="Páginas dinâmicas"
            to="/dynamic_pages"
          />
          <NavGroup
            icon={AiOutlineMenu}
            title="Itens de Menu"
            items={dataFromContext?.map((location: any) => ({
              title: location?.name,
              to: `/menu-items/${location?.slug}`,
            }))}
          />
          <NavItem
            icon={AiOutlineFileText}
            title="Locais para itens de menu"
            to="/menu-items-location"
          />
          <NavItem
            icon={CgList}
            title="Vitrines dinâmicas"
            to="/dynamic_showcase"
          />
          <NavItem
            icon={BsBagCheck}
            title="Vitrines de recomendação"
            to="/recommendation-showcases"
          />
          <NavItem icon={BsPercent} title="Cupons" to="/coupons" />
          <NavItem icon={BsTag} title="Preço mais barato" to="/cheaper-price" />
          <NavItem
            icon={BsImages}
            title="Diagnóstico de mídia"
            to="/media-diagnostics"
          />
          <NavItem icon={BsGear} title="Configurações" to="/configs" />
          {isSysAdmin && (
            <>
              <NavItem
                icon={BsShieldCheck}
                title="Admin"
                to="/cmsadmin"
                borderTop="2px"
                borderColor="gray.200"
              />
            </>
          )}
        </>
      </VStack>
    </Flex>
  );
};

export default Aside;
